import {
  SET_PAGE,
  SET_SEARCH_TEXT,
  SET_SORT,
  SET_FILTERS,
  RESET_ALL_FILTERS,
} from "actions/ActionTypes";

export const set_page = (currentPage, perPage, item) => ({
  type: SET_PAGE,
  currentPage,
  perPage,
  item,
});

export const set_search_text = (searchText, item) => ({
  type: SET_SEARCH_TEXT,
  item,
  searchText,
});

export const set_sort = (sort, item) => ({
  type: SET_SORT,
  item,
  sort,
});

export const set_filters = (filters, item) => ({
  type: SET_FILTERS,
  item,
  filters,
});

export const reset_all_filters = (
  currentPage,
  perPage,
  item,
  itemType = null,
) => ({
  type: RESET_ALL_FILTERS,
  item,
  itemType,
  currentPage,
  perPage,
});
